module.exports = __webpack_public_path__ + "static/media/dashboard-mobile-icon.26f1bc8f.svg";